import { useNavigate } from "react-router-dom";
import styles from "./SignedOut.module.css";

const SignedOut = () => {
  const navigate = useNavigate();

  return (
    <main className={styles.page}>
      <section className={styles.card} aria-labelledby="signed-out-title">
        <p className={styles.eyebrow}>SOMA Portal</p>
        <h1 id="signed-out-title">You&apos;ve signed out</h1>
        <p>Thanks for using SOMA. We hope to see you again soon.</p>
        <button className={styles.signInButton} onClick={() => navigate("/", { replace: true })}>
          Sign in
        </button>
      </section>
    </main>
  );
};

export default SignedOut;
